import { render, staticRenderFns } from "./edit_shipping.vue?vue&type=template&id=e2ceb2d4&scoped=true"
import script from "./edit_shipping.vue?vue&type=script&lang=js"
export * from "./edit_shipping.vue?vue&type=script&lang=js"
import style0 from "./edit_shipping.vue?vue&type=style&index=0&id=e2ceb2d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ceb2d4",
  null
  
)

export default component.exports